import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import clsx from 'clsx';
import { tabPanelHidden } from './tabs-primitive.css.js';

function TabPanelPrimitiveInner({ children, display, id, manager, triggerId, panelId, className, forceMount, ...props }, ref) {
    const hidePanel = !display || id !== manager.activeTab;
    if (hidePanel && !forceMount) {
        return null;
    }
    return (jsx("div", { "data-fpl-component": "primitive", ...props, ref: ref, className: clsx(className, {
            [tabPanelHidden]: hidePanel,
        }), role: "tabpanel", "aria-labelledby": triggerId, id: panelId, children: children }));
}
TabPanelPrimitiveInner.displayName = 'TabsPrimitive.TabPanel';
/**
 * TabsPrimitive.TabPanel is an unstyled (“headless”) component used to display tab content.
 * Use `TabsPrimitive.TabPanel` only if you need custom styling; otherwise, use
 * `Tabs.TabPanel`. @see https://fpl.figma.design/components/tabs/
 */
const TabPanelPrimitive = forwardRef(TabPanelPrimitiveInner);

export { TabPanelPrimitive };
//# sourceMappingURL=tab-panel-primitive.js.map
